module.exports = __webpack_public_path__ + "static/gallery-11-cc72880a7f8aedb1aabb5ac8632689e2.jpg";